

export default{
  KIND: {
      FORMATION: "FORMATION",
      INCORPORATED:"INCORPORATED"
  },
}